const prizeButtons = [
    {
        type: 'auto select mode',
        src: '/assets/images/AUTO SELECT MODE.png',
        numOfPrizes: 1,
    },
    {
        type: 'multiple mode',
        src: '/assets/images/MULTIPLE MODE.png',
        numOfPrizes: 6,
    },
    {
        type: '12 prizes multiple mode',
        src: '/assets/images/EMOJI GAME PRIZE SELECTOR 12_0.png',
        numOfPrizes: 12,
    },
    {
        type: '18 prizes multiple mode',
        src: '/assets/images/EMOJI GAME PRIZE SELECTOR 12 18_118.png',
        numOfPrizes: 18,
    },
    {
        type: '24 prizes multiple mode',
        src: '/assets/images/EMOJI GAME PRIZE SELECTOR 12 24_123.png',
        numOfPrizes: 24,
    },
    {
        type: '30 prizes multiple mode',
        src: '/assets/images/EMOJI GAME PRIZE SELECTOR 12 30_181.png',
        numOfPrizes: 30,
    },
    {
        type: '36 prizes multiple mode',
        src: '/assets/images/EMOJI GAME PRIZE SELECTOR 12 36_243.png',
        numOfPrizes: 36,
    },
    {
        type: '42 prizes multiple mode',
        src: '/assets/images/EMOJI GAME PRIZE SELECTOR 12 42_302.png',
        numOfPrizes: 42,
    },
    {
        type: '48 prizes multiple mode',
        src: '/assets/images/EMOJI GAME PRIZE SELECTOR 12 48_368.png',
        numOfPrizes: 48,
    }
];

export { prizeButtons };